import React from 'react';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/style/user.mypage.module.scss';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function ProfileInfo(props) {
    const { info } = usePartnerStore();

    return (
        <Element tag={`div`} className={styles.partnerContainer}>
            <Element tag={`div`} className={styles.imgArea}><img src={`${process.env.REACT_APP_IMAGE_URL + info.IMG_SRC}`} alt={info.PARTNER_NAME} /></Element>
            <Element tag={`div`} className={styles.infoArea}>
                <Element tag={`div`}><Element tag={`h1`}>{info.PARTNER_NAME}</Element><Element tag={`button`} anyprop={(e) => props.onDismiss(true)}><FontAwesomeIcon icon="fa-light fa-pen-line" /></Element></Element>
                <Element tag={`p`}>{info.SUMMARY !== undefined && info.SUMMARY !== null ? info.SUMMARY : `${info.PARTNER_NAME}을 소개해주세요.`}</Element>
                <Element tag={`small`}><Element tag={`span`}>정비인원 {info.MECHANIC}명</Element></Element>
            </Element>
        </Element>
    );
}